import { ExtensionType, extensions } from '@pixi/extensions';

class StartupSystem {
  constructor(renderer) {
    this.renderer = renderer;
  }
  run(options) {
    const renderer = this.renderer;
    renderer.emitWithCustomOptions(renderer.runners.init, options);
    if (options.hello) {
      console.log(`PixiJS ${"7.0.5"} - ${renderer.rendererLogId} - https://pixijs.com`);
    }
    renderer.resize(this.renderer.screen.width, this.renderer.screen.height);
  }
  destroy() {
  }
}
StartupSystem.extension = {
  type: [
    ExtensionType.RendererSystem,
    ExtensionType.CanvasRendererSystem
  ],
  name: "startup"
};
extensions.add(StartupSystem);

export { StartupSystem };
//# sourceMappingURL=StartupSystem.mjs.map
